export class DashboardRequestModel {
   ID: number;
   TotalOfRequest: number;
   Checking: number;
   InProgress: number;
   WaitingFFMApproval: number;
   _Return: number;
    Complete: number;
    OpenRequest: number;
}
